export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[580px] md:min-h-[620px] flex items-center overflow-hidden pt-[56px] md:pt-[64px]">
      <div className="absolute inset-0 bg-background-100">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-100/60 via-background-50 to-accent-100/40"></div>
        <div className="absolute top-0 right-0 w-[60%] h-full opacity-[0.12]"
          style={{
            backgroundImage: 'radial-gradient(circle at 70% 50%, oklch(0.54 0.23 25 / 0.5) 0%, transparent 60%)',
          }}
        ></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs md:text-sm font-medium mb-5 md:mb-6">
              <i className="ri-fire-line text-sm"></i>
              <span>每日更新 · 全网热播</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-foreground-950 leading-tight mb-3 md:mb-4">
              桃花视频
              <span className="block text-primary-600 text-xl sm:text-2xl md:text-3xl font-semibold mt-2">
                聚合全网优质影视 · 高清流畅免费看
              </span>
            </h1>

            <p className="text-foreground-500 text-sm md:text-base leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-4">
              桃花视频聚合红桃视频、樱桃视频、茄子视频、糖心视频等主流平台内容资源，
              每日同步更新最新电视剧、热门电影、人气综艺与精彩短视频。
              无需注册、无需付费，打开即看，高清流畅不卡顿，打造一站式追剧观影新体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-6 md:mb-8">
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-foreground-900">10W+</div>
                <div className="text-xs text-foreground-400">影视资源</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-foreground-900">每日更新</div>
                <div className="text-xs text-foreground-400">同步热播</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-foreground-900">高清流畅</div>
                <div className="text-xs text-foreground-400">无需缓冲</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="w-full sm:w-auto px-7 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg text-sm whitespace-nowrap transition-colors cursor-pointer text-center"
              >
                <i className="ri-play-circle-line mr-2"></i>立即观看
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-7 py-3 bg-background-50 hover:bg-background-200 border border-background-300 text-foreground-700 font-medium rounded-lg text-sm whitespace-nowrap transition-colors cursor-pointer text-center"
              >
                <i className="ri-trophy-line mr-2"></i>热播榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px] flex-shrink-0">
            <div className="relative rounded-xl overflow-hidden aspect-[4/3] bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinematic%20abstract%20composition%20with%20soft%20gradient%20curves%20in%20coral%20red%20and%20warm%20amber%20tones%2C%20minimalist%20geometric%20shapes%20evoking%20film%20reels%20and%20play%20buttons%2C%20smooth%20silky%20texture%20with%20gentle%20light%20effects%2C%20elegant%20modern%20entertainment%20aesthetic%2C%20no%20text%2C%20clean%20composition%2C%204k%20quality&width=1040&height=780&seq=hero-main-visual&orientation=landscape"
                alt="桃花视频 - 高清影视聚合平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0 cursor-pointer">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </span>
                <div className="flex-1 min-w-0">
                  <div className="text-xs text-white/80 font-medium">正在热播</div>
                  <div className="text-sm text-white font-semibold truncate">最新热播剧集 · 每日同步更新</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}